import _ from "lodash";
import React, { useState } from "react";
import { Button, Modal, Checkbox } from "@toddle-edu/ds-web";
import classes from "./ChannelSettingModal.scss";
import classNames from "classnames";
import { updateChannelSettings } from "MessagingV2/modules/MessagingModule";
import { connect } from "react-redux";
import { useI18n } from "Hooks";
import {
  isMessagingRevempEnabled,
  CHAT_TYPE_ENUM,
} from "MessagingV2/modules/Utils";

const CHANNEL_SETTINGS_CONFIG = {
  student: "student",
  parent: "parent",
};

const getModalStyle = ({ isUIRevempEnabled }) => {
  return isUIRevempEnabled
    ? { height: "680px", width: "600px" }
    : { height: "600px", width: "611px" };
};

const CheckBoxOption = ({ option, setFormData, formData }) => {
  const { label, description, isDisabled, formKey } = option;

  const handleOnToggle = () => {
    setFormData(formData => ({ ...formData, [formKey]: !formData[formKey] }));
  };

  return (
    <div className={classes.checkBoxContainerWrapper}>
      <div className={classes.checkBoxContainer}>
        <div className={classNames(classes.checkBoxLabel, "text-body-1")}>
          {label}
        </div>
        <Checkbox
          onChange={handleOnToggle}
          isChecked={formData[formKey]}
          disabled={isDisabled}
        />
      </div>
      <div
        className={classNames(classes.checkBoxDescription, "text-subtitle-3")}
      >
        {description}
      </div>
    </div>
  );
};

const getChecklistOptions = ({ t, channelType }) => {
  const checkListOptions = [
    {
      label: t("common:from_label", {
        label: t("common:student_plural_lowercase"),
      }),
      description: t("common:channel_settings_options_description_with_label", {
        label: t("common:student_plural"),
      }),
      key: "disable_students_messages",
      isDisabled: false,
      formKey: "student",
      visibleChatTypes: [
        CHAT_TYPE_ENUM.CHANNEL_CUSTOM,
        CHAT_TYPE_ENUM.CHANNEL_SYSTEM_MANAGED,
      ],
    },
    {
      label: t("common:from_label", {
        label: t("common:family_member_plural_lowercase"),
      }),
      description: t("common:channel_settings_options_description_with_label", {
        label: t("common:family_member_plural"),
      }),
      key: "disable_family_members_messages",
      isDisabled: false,
      formKey: "parent",
      visibleChatTypes: [
        CHAT_TYPE_ENUM.CHANNEL_CUSTOM,
        CHAT_TYPE_ENUM.CHANNEL_FAMILY,
      ],
    },
  ];

  return _.filter(checkListOptions, option => {
    return _.includes(option.visibleChatTypes, channelType);
  });
};

const ChannelSettingModal = props => {
  const {
    onCloseModal,
    channelLabel,
    chatId,
    updateChannelSettings,
    viewOnlyRoles,
    channelType,
  } = props;

  const { t } = useI18n(["common", "teacherHomePage"]);
  const isUIRevempEnabled = isMessagingRevempEnabled();

  const checkListOptions = getChecklistOptions({
    t,
    channelType,
  });

  const formDataInit = _.reduce(
    [CHANNEL_SETTINGS_CONFIG.student, CHANNEL_SETTINGS_CONFIG.parent],
    (acc, key) => {
      acc[key] = _.includes(viewOnlyRoles, key);
      return acc;
    },
    {}
  );

  const [formData, setFormData] = useState(formDataInit);
  const [isSubmitDisable, setIsSubmitDisable] = useState(false);

  const onSubmit = async () => {
    setIsSubmitDisable(true);

    const viewOnlyRolesInput = _.reduce(
      formData,
      (acc, value, key) => {
        if (value) {
          acc.push(key);
        }
        return acc;
      },
      []
    );

    await updateChannelSettings({ viewOnlyRoles: viewOnlyRolesInput, chatId });

    setIsSubmitDisable(false);
    onCloseModal();
  };
  const modalStyle = getModalStyle({ isUIRevempEnabled });

  return (
    <Modal
      height={modalStyle.height}
      width={modalStyle.width}
      onClose={onCloseModal}
    >
      <Modal.Header
        title={t("common:channel_settings_with_label", { label: channelLabel })}
        isClosable={true}
        hasSeparator={isUIRevempEnabled}
      />
      <Modal.Body>
        <div className={classes.modalBodyContainer}>
          <div className={classNames(classes.modalBodyHeading, "heading-5")}>
            {t("common:disable_label_lowercase", {
              label: t("teacherHomePage:messages"),
            })}
          </div>
          <div className={classes.optionsContainerWrapper}>
            {_.map(checkListOptions, ({ key, ...option }) => (
              <CheckBoxOption
                option={option}
                key={key}
                formData={formData}
                setFormData={setFormData}
              />
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer hasSeparator={true}>
        <div className={classes.footerContainer}>
          <Button variant="outlined-subtle" size="large" onClick={onCloseModal}>
            {t("common:cancel")}
          </Button>
          <Button
            variant="progressive"
            size="large"
            onClick={onSubmit}
            disabled={isSubmitDisable}
          >
            {t("common:update")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
const mapActionCreator = {
  updateChannelSettings,
};
export default connect(null, mapActionCreator)(ChannelSettingModal);
